<script setup lang="ts">
import { type Component } from "vue";
import { AlertCircle } from "@lucide/vue";

interface Props {
  message: string;
  description?: string;
  icon?: Component;
}

withDefaults(defineProps<Props>(), {
  icon: () => AlertCircle,
});
</script>

<template>
  <div
    role="status"
    class="flex h-full flex-col items-center justify-center gap-2 px-6 py-8 text-center"
  >
    <component
      :is="icon"
      aria-hidden="true"
      class="mb-2 h-9 w-9 shrink-0 text-text-muted"
    />
    <p class="text-sm font-semibold text-text-primary">
      {{ message }}
    </p>
    <p
      v-if="description"
      class="max-w-sm text-sm leading-relaxed text-text-muted"
    >
      {{ description }}
    </p>
  </div>
</template>
